
import { defineComponent, computed } from 'vue'

export default defineComponent({
  props: {
    modelValue: {
      type: [Number, String]
    },
    step: {
      type: Number,
      default: 1
    },
    controls: {
      type: String,
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    controlSize: {
      type: Number
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    }
  },
  emits: ['update:modelValue'],
  setup (props, {emit}) {
    if (typeof props.modelValue === 'string') emit('update:modelValue', parseInt(props.modelValue))
    return {
      value: computed({
        get: () => {
          return props.modelValue || 0
        },
        set: (value) => {
          emit('update:modelValue', value)
        }
      })
    }
  },
})
